module.exports = __webpack_public_path__ + "static/img/huangguan.b95488b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huangguan.png
// module id = iAwy
// module chunks = 1